// removed by extract-text-webpack-plugin
module.exports = {"container":"ReferenceReplacement-module-container-323nH","references-list":"ReferenceReplacement-module-references-list-2y7AL","referencesList":"ReferenceReplacement-module-references-list-2y7AL","reference-pill":"ReferenceReplacement-module-reference-pill-2tPz5","referencePill":"ReferenceReplacement-module-reference-pill-2tPz5","see-more":"ReferenceReplacement-module-see-more-39l-L","seeMore":"ReferenceReplacement-module-see-more-39l-L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchItem/components/ReferenceReplacement.module.scss
// module id = 923
// module chunks = 0